import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  blogs: [],
  totalCount: 0,
  loading: false,
  error: null,
  currentPage: 1,
  pageSize: 10,
  selectedBlog: null,
};

const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    clearBlogs: (state) => {
      state.blogs = [];
      state.totalCount = 0;
      state.currentPage = 1;
    },
    setSelectedBlog: (state, action) => {
      state.selectedBlog = action.payload;
    },
    fetchFilteredBlogs: (state, action) => {
      if (action.payload && action.payload.data && action.payload.data.items) {
        state.blogs = action.payload.data.items.map(blog => ({
          ...blog,
          author: `${blog.authorName} ${blog.authorLastName}`,
        }));
        state.totalCount = action.payload.count;
      } else {
        state.blogs = [];
        state.totalCount = 0;
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  setCurrentPage,
  setPageSize,
  clearBlogs,
  setSelectedBlog,
  fetchFilteredBlogs,
  setLoading,
  setError,
} = blogSlice.actions;

export default blogSlice.reducer; 